import React from 'react';
import './DistributeCounter.css';

export default class DistributeCounter extends React.Component {


  render() {
    return (
      <div className='distributeCounter'>

        <div className='col s6 m6 l6'>
          <b>Titulares</b>
          <div className='counter'>{this.props.holders}</div>
        </div>

        <div className='col s6 m6 l6'>
          <b >Vidas</b>
          <div className='counter'>{this.props.lives}</div>
        </div>

        <div className='col s12 m12 l12 '>
          &nbsp;
        </div>

        <div className='col s12 m12 l12 '>
          <b >Vidas Restantes</b>
          <div className='counter'>{this.props.remainingLives}</div>
        </div>
      </div >
    );
  }
};

